import { Text, Anchor, Accordion } from '@mantine/core';

interface FAQItem {
  question: string;
  answer: string | React.ReactNode;
}

const faqItems: FAQItem[] = [
  {
    question: 'What is Rankify?',
    answer:
      "Rankify is a playful, structured space to spark creative challenges, deepen community discussions, and showcase your unique tastes and skills. Whether you're vibing with music playlists, solving puzzles, or building consensus in your community, Rankify is your launchpad for creativity and recognition. Use it in comfy Web2 mode or tap into Web3 features like tokens and DAOs — your choice!",
  },
  {
    question: 'What are Arenas (formerly Fellowships)?',
    answer:
      "Arenas are where the fun begins! They're themed challenge spaces where you can collaborate, compete, and show off what makes your spark unique. From crafting the ultimate playlist to creating clever writing prompts or puzzles, Arenas let you shine in whatever you're passionate about. Think of them as Rankify’s creative playgrounds.",
  },
  {
    question: 'What is a Thread?',
    answer:
      'A Thread on Rankify is more than just a chat — it’s a structured game of discussion. Threads operate in timed, turn-based rounds that keep everything fair, focused, and engaging. It’s how ideas surface and decisions get made — with clarity and flow, not chaos.',
  },
  {
    question: 'What is a Round Robin Discussion?',
    answer:
      "In Round Robin mode, everyone gets a fair turn. Proposals are anonymous during creation, so it's about the idea — not the person. Each round gives you a chance to propose and vote, promoting balance, focus, and fair participation.",
  },
  {
    question: 'What is the Quadratic Voting System?',
    answer:
      "Quadratic Voting lets you show how much you care, not just what you prefer. This way, you can support multiple ideas, but if you really love one, you'll need to invest more — making votes fair and balanced.",
  },
  {
    question: 'What is Consensus Building?',
    answer:
      'It&apos;s the art of finding that sweet spot where most people feel good about a decision. Rankify makes it easier — with tools that help your community agree without the usual headaches.',
  },
  {
    question: 'How can I use Rankify?',
    answer:
      "Start by creating a Thread or joining an Arena challenge. Whether you're aligning your team's vision, settling debates, or just trying to create the best playlist — Rankify brings clarity, creativity, and structure to the process. Share a link and invite others to jump in!",
  },
  {
    question: 'Is Rankify a Web3 project?',
    answer:
      'Rankify plays well with Web3 — tokens, DAOs, wallet logins — all are welcome. But you can also enjoy Rankify in comfy Web2 mode. No wallet? No problem.',
  },
  {
    question: 'I have an existing Discord server. How can I use Rankify there?',
    answer:
      'Easy! You can install our Rankify Bot on your server. Fellowships can be set up to post directly inside your Discord — no need to hang out in Peeramid Labs if you already have your own space.',
  },
  {
    question: 'How do I install Rankify Bot on my server?',
    answer: (
      <>
        Rankify Bot is your server-side buddy. You&apos;ll find the invite and setup guide in our{' '}
        <Anchor
          href="https://discord.com/channels/1231134572813615105/1372148627513802804"
          target="_blank"
          rel="noopener noreferrer"
        >
          Bot Setup channel
        </Anchor>
        . It&apos;s plug-and-play, no wizard degree needed.
      </>
    ),
  },
  {
    question: 'What happens after BETA?',
    answer:
      'After Beta, we&apos;ll open up Rankify to more communities, polish the experience, and add more cool features. Plus, your feedback will shape what comes next — you&apos;re part of the adventure.',
  },
  {
    question: 'What is Arbsepolia?',
    answer:
      "Arbsepolia is the test network (testnet) where we play with Web3 features like tokens and DAOs — safely, without using real funds. It's like the practice field for Rankify's web3 side.",
  },
  {
    question: 'Can I use Rankify with other chat platforms?',
    answer:
      "For now, you can join Threads right on our web app or bring them into your Discord with the Rankify Bot. We've got a soft spot for Discord — it's where Rankify starting. But are we cooking up plans to support more platforms like Telegram, Farcaster? Yep, they're on our wishlist too — but we're evolving with our users.",
  },
  {
    question: 'I need help or support. What should I do?',
    answer: (
      <>
        Easy — just post your question in our{' '}
        <Anchor
          href="https://discord.com/channels/1231134572813615105/1371943106571669545"
          target="_blank"
          rel="noopener noreferrer"
        >
          Support Forum channel
        </Anchor>
        . Someone from the crew or the community will jump in to help you out.
      </>
    ),
  },
];

export function FAQContent() {
  return (
    <Accordion mt="md">
      {faqItems.map((item, index) => (
        <Accordion.Item key={index} value={item.question}>
          <Accordion.Control>
            <Text fw={500} size="lg">
              {item.question}
            </Text>
          </Accordion.Control>
          <Accordion.Panel>
            <Text>{item.answer}</Text>
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}
